export const METADATA_DEAL_FETCH = 'deal';
export const METADATA_SPONSOR_FETCH = 'sponsor';
export const METADATA_USER_FETCH = 'user';
export const USER_LOGOUT = 'logout';
export const USER_FETCH = 'user';
export const FORM_SET_ERROR = 'set_error';
export const FORM_CLEAR_ERROR = 'clear_error';
